module.exports = __webpack_public_path__ + "img/20.e9001920.gif";